import CloneIcon from '@clearkit/icons/glyphs/Clone';
import Ellipsis from '@clearkit/icons/glyphs/Ellipsis';
import { CKButton } from '@clearkit/react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';

import MenuItem from '~/components/RedesignedMenuItem';
import { audienceIsClonable } from '~/lib/audiences';
import paths from '~/lib/paths';
import DestroyHandler from '~/pages/audiences/components/DestroyHandler';
import ExportAudienceLinkedin from '~/pages/audiences/components/Layout/ActionsMenu/ExportAudienceLinkedin';

import DeleteIcon from './Delete.svg';
import ExportAudience from './ExportAudience';

class AudiencesLayoutActionsMenu extends React.Component {
  state = {
    isMenuOpen: false,
  };

  anchor = React.createRef();

  openMenu = () => {
    this.setState({ isMenuOpen: true });
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    const { audience, viewer } = this.props;
    const { isMenuOpen } = this.state;

    const disabled = !audience;

    return (
      <div ref={this.anchor}>
        <CKButton disabled={disabled} onClick={this.openMenu}>
          <Ellipsis height={32} />
        </CKButton>

        {audience && (
          <Menu
            anchorEl={this.anchor.current}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            getContentAnchorEl={null}
            onClose={this.closeMenu}
            open={isMenuOpen}>
            {viewer?.canExportAudiences && (
              <MenuItem>
                <ExportAudience onExport={this.closeMenu} audience={audience} />
              </MenuItem>
            )}
            {viewer?.canExportAdAudiencesToLinkedin && (
              <MenuItem primary>
                <ExportAudienceLinkedin
                  onExport={this.closeMenu}
                  audience={audience}
                />
              </MenuItem>
            )}

            {audienceIsClonable(audience) ? (
              <MenuItem>
                <ListItemIcon>
                  <CloneIcon />
                </ListItemIcon>
                <Link
                  to={paths.audienceClone(audience.id)}
                  className="text-gray-600">
                  Clone audience
                </Link>
              </MenuItem>
            ) : null}

            <DestroyHandler audience={audience}>
              <MenuItem variant="destructive">
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                Delete audience
              </MenuItem>
            </DestroyHandler>
          </Menu>
        )}
      </div>
    );
  }
}

AudiencesLayoutActionsMenu.propTypes = {
  audience: PropTypes.object,
  viewer: PropTypes.object,
};

export default AudiencesLayoutActionsMenu;
